import React from 'react';

import CSCOVerticalSection from './CSCOVerticalSection';
import CSUtil from "../util/CSUtil";
import CSFormUtil from "../util/CSFormUtil";

const mFormUtil        = CSFormUtil.cfGetInstance();
const mDefaultMaxSecs  = 4;   // fallback if max_sections_ not defined

const CSCODetailsHeader = (lProps) =>
{
    const cfGetSections = (lFormItemList) =>
    {
        let lSections = [];

        if (!lFormItemList || lFormItemList.length === 0) {
            return lSections;
        }

        //
        // 1) Resolve max_sections_ for THIS header form code
        //
        let lMaxSections = mDefaultMaxSecs;
        let lFormCode = null;

        // sort once
        const lSortedList = [...lFormItemList];
        CSUtil.cfSort(lSortedList, "sequence_");

        if (lSortedList.length > 0) {
            lFormCode = lSortedList[0].cs_form_code_;
        }

        if (lProps.pFormProperties && lFormCode) {
            for (let pInd = 0; pInd < lProps.pFormProperties.length; pInd++) {
                const lProperty = lProps.pFormProperties[pInd];
                if (
                    lProperty &&
                    lProperty.cs_form_code_ === lFormCode &&
                    lProperty.property_ === "max_sections_"
                ) {
                    const lVal = Number(lProperty.value_);
                    if (!isNaN(lVal) && lVal > 0) {
                        lMaxSections = lVal;
                    }
                }
            }
        }

        //
        // 2) Split image vs other items (honour visible_)
        //
        let lPicFormItem = null;
        let lFieldItemList = [];

        for (let ind = 0; ind < lSortedList.length; ind++) {
            const lItem = lSortedList[ind];

            if (lItem.visible_ === "0") {
                continue;
            }

            if (lItem.control_type_ === "image" && !lPicFormItem) {
                lPicFormItem = { ...lItem };
                // keep current behaviour: enable browse + camera
                lPicFormItem.pEnableBrowse = true;
                lPicFormItem.pEnableCamera = true;
            } else {
                lFieldItemList.push(lItem);
            }
        }

        const lLooseCount = lFieldItemList.length;
        if (!lPicFormItem && lLooseCount === 0) {
            return lSections;
        }

        //
        // 3) Decide number of sections
        //    - max_sections_ is TOTAL sections (image + fields)
        //    - cannot have more field sections than items
        //
        let lNumSections   = 0;   // total (image + fields)
        let lLooseSections = 0;   // sections that hold fields

        if (lPicFormItem) {
            if (lLooseCount === 0) {
                // only image
                lNumSections   = 1;
                lLooseSections = 0;
            } else {
                const lMaxAllowedSections =
                    (lMaxSections && lMaxSections > 0)
                        ? lMaxSections
                        : (1 + lLooseCount);

                // sections available for fields (at least 1 if we have fields)
                let lMaxLooseSections = Math.max(1, lMaxAllowedSections - 1);

                lLooseSections = Math.min(lLooseCount, lMaxLooseSections);
                lNumSections   = 1 + lLooseSections;
            }
        } else {
            if (lLooseCount === 0) {
                return lSections;
            }

            const lMaxAllowedSections =
                (lMaxSections && lMaxSections > 0)
                    ? lMaxSections
                    : lLooseCount;

            lLooseSections = Math.min(lLooseCount, lMaxAllowedSections);
            lNumSections   = lLooseSections;
        }

        //
        // 4) Balanced distribution of fields across loose sections
        //    e.g. 9 items, maxSections=5 (no image) -> [2,2,2,2,1]
        //
        let lSectionNumControlMap = {};
        let lMaxSectionItems = 0;

        let lBaseCount = 0;
        let lExtra     = 0;

        if (lLooseSections > 0) {
            lBaseCount = Math.floor(lLooseCount / lLooseSections);
            lExtra     = lLooseCount % lLooseSections;  // first lExtra sections get +1
        }

        let lItemIdx = 0;

        for (let s = 0; s < lNumSections; s++) {
            const lSectionIndex = s;
            let lSectionControlList = [];

            if (lPicFormItem && s === 0) {
                // section 0 = image
                lSectionControlList.push(
                    mFormUtil.cfGetControl(
                        lPicFormItem,
                        lProps.pProcessChange,
                        null,
                        null,
                        lProps.pOnPopout
                    )
                );
            } else if (lLooseSections > 0) {
                const lFieldSectionIndex = lPicFormItem ? (s - 1) : s;
                const lCount = lBaseCount + (lFieldSectionIndex < lExtra ? 1 : 0);

                for (let c = 0; c < lCount; c++) {
                    if (lItemIdx >= lLooseCount) break;

                    const lFormItem = lFieldItemList[lItemIdx++];
                    lSectionControlList.push(
                        mFormUtil.cfGetControl(
                            lFormItem,
                            lProps.pProcessChange,
                            null,
                            null,
                            lProps.pOnPopout
                        )
                    );
                }
            }

            lMaxSectionItems = Math.max(lMaxSectionItems, lSectionControlList.length);
            lSectionNumControlMap[lSectionIndex] = lSectionControlList;
        }

        //
        // 5) Render CSCOVerticalSection components
        //
        for (let lSectionNum = 0; lSectionNum < lNumSections; lSectionNum++) {
            const lSection =
                <CSCOVerticalSection
                    pId               = { lSectionNum }
                    pSectionNo        = { lSectionNum }
                    key               = { lSectionNum }
                    pNumSections      = { lNumSections }
                    pMaxSectionItems  = { lMaxSectionItems }
                    pIsCriteriaSection= { false }
                    pChildren         = { lSectionNumControlMap[lSectionNum] }
                />;

            lSections.push(lSection);
        }

        return lSections;
    };

    let lForm = null;
    if (lProps.pFormItems && lProps.pFormItems.length > 0) {
        lForm =
            <div className="fluid flex">
                { cfGetSections(lProps.pFormItems) }
            </div>;
    }

    return lForm;
};

export default CSCODetailsHeader;
